// Optional payload on setActiveMatterId — tells the matters listener whether to emit
// MatterSelectionChanged. Keeps session rehydration out of "matter opened" metrics.
export enum SetActiveMatterSource {
  SessionRestore = 'session_restore',
}
